var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("appStore.apps"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.syncing },
              on: { click: _vm.syncApps },
            },
            [
              _c("a-icon", { attrs: { type: "sync" } }),
              _vm._v(
                " " + _vm._s(_vm.$t("appStore.syncApps")) + "\n            "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            { attrs: { loading: _vm.loading }, on: { click: _vm.fetchApps } },
            [
              _c("a-icon", { attrs: { type: "reload" } }),
              _vm._v(
                " " + _vm._s(_vm.$t("appStore.refresh")) + "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "help-text" },
      [
        _c("a-icon", { attrs: { type: "info-circle" } }),
        _vm._v(" " + _vm._s(_vm.$t("appStore.appsAutoFetch")) + "\n    "),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "apps-container" },
          _vm._l(_vm.apps, function (app) {
            return _c("div", { key: app._id, staticClass: "app-card" }, [
              _c("div", { staticClass: "app-icon" }, [
                app.iconUrl
                  ? _c("img", { attrs: { src: app.iconUrl } })
                  : _c("span", { staticClass: "material-icons" }, [
                      _vm._v("phone_iphone"),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("h3", { staticClass: "app-name" }, [
                  _vm._v(_vm._s(app.name)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bundle-id" }, [
                  _vm._v(_vm._s(app.bundleId)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta" }, [
                  app.totalReviewCount
                    ? _c("span", [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("reviews"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(app.totalReviewCount) +
                            " reviews\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  app.primaryLocale
                    ? _c("span", [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("language"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(app.primaryLocale) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  app.lastSyncedAt
                    ? _c("span", [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("sync"),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDate(app.lastSyncedAt)) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: {
                        size: "small",
                        loading: _vm.syncingApp === app._id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.syncReviews(app)
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "sync" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("appStore.syncReviews")) +
                          "\n                "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          }),
          0
        )
      : _c("div", { staticClass: "loading" }, [_c("a-spin")], 1),
    _vm._v(" "),
    !_vm.loading && _vm.apps.length === 0
      ? _c(
          "div",
          { staticClass: "empty" },
          [
            _c(
              "a-empty",
              { attrs: { description: _vm.$t("appStore.noAppsFound") } },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", loading: _vm.syncing },
                    on: { click: _vm.syncApps },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("appStore.syncApps")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }